import { useState } from "react";
import { IconArrowDown } from "@/assets/images/Icons";
import { Link, Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { ShieldCheck } from "lucide-react";

export default function DropdownButton() {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const queryClient = useQueryClient();

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    toast.success("Deslogado com Sucesso!");
    queryClient.clear(); // Limpa o cache do React Query
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative inline-block text-left cursor-pointer">
      <button
        type="button"
        className="flex items-center gap-2 text-cinza-200 hover:text-azul-400 duration-200"
        onClick={toggleDropdown}
      >
        <IconArrowDown />
      </button>
      {isOpen && (
        <div className="absolute left-0-0 w-64 mt-2 origin-top-right bg-white rounded-xl overflow-hidden shadow-lg z-10">
          <div
            className="fixed w-full h-full top-0 right-0 -z-10"
            onClick={toggleDropdown}
          />
          <Link
            to="/editar-usuario"
            onClick={toggleDropdown}
            className="px-4 py-2 text-cinza-300 hover:text-white hover:bg-azul-400 duration-300 flex items-center gap-4 w-full"
          >
            <img
              src={"/icons/perfil.svg"}
              alt="Icon"
              width={19}
              height={22}
              className="text-cinza-300"
            />
            Perfil
          </Link>

          <Link
            to="/perfil/seguranca"
            onClick={toggleDropdown}
            className="px-4 py-2 text-cinza-300 hover:text-white hover:bg-azul-400 duration-300 flex items-center gap-4 w-full"
          >
            <ShieldCheck size={19} />
            Segurança
          </Link>

          <button
            onClick={handleLogout}
            className="px-4 py-2 text-cinza-300 hover:text-white hover:bg-azul-400 duration-300 flex items-center gap-4 w-full"
          >
            <img
              src={"/icons/sair.svg"}
              alt="Icon"
              width={19}
              height={22}
              className="text-cinza-300"
            />
            Sair
            {!isLoggedIn && <Navigate to="/login" />}
          </button>
        </div>
      )}
    </div>
  );
}
